import { z } from 'zod'

import { timeframeSchema } from '../misc/timeframe.ts'
import { fieldTypeSchema } from '../query/index.ts'

// NOTE: typeを編集した時のためにdimensionに関わるロジックを整理しておくと
// [core] getUiDimensionCandidates
// [core] constant
// [client] KpiParameterSider: DimensionPicker
// [core] compileKpiViewConfig
// [core] compileSheetViewConfigMeasures
// [core] searchFieldAndPropertyForDimension: findDimensionField
// [client] usePivotColumns
// [core] compileKpiPivotViewConfig
// [client] ViewDrillDownModal
// [client] ViewUIKpiSheet/DimensionAdditionForm
const viewUiDimensionCandidateCommonSchema = z.object({
  key: z.string(),
  fieldType: fieldTypeSchema,
  label: z.string(),
  // 以下はこのレイヤで定義するものではないが、config側でunionのマージができないので、仕方なくここで定義している
  dateSpan: timeframeSchema.optional(), // 日付のフィールドをどうグルーピングするか
  // numericSpan: z.number().array().optional(), // 数値のフィールドをどうグルーピングするか
  dimensionCount: z.number().optional(), // kpi_pivotでの利用を想定。いくつのKPI(measure)でこのdimensionが使えるか
  sortedValues: z.string().array().optional(),
})

const viewUiDimensionCandidatePropertySchema = viewUiDimensionCandidateCommonSchema.extend({
  type: z.literal('property'),
  // property: nodePropertyNameSchema, // なぜかこれで実行時エラーになった
  property: z.object({
    nodeName: z.string(),
    modelName: z.string(),
    propertyName: z.string(),
  }),
})
export type ViewUiDimensionCandidateProperty = z.infer<typeof viewUiDimensionCandidatePropertySchema>

const viewUiDimensionCandidateFieldNameSchema = viewUiDimensionCandidateCommonSchema.extend({
  type: z.literal('fieldName'), // KPIのときのみ利用予定
  fieldName: z.string(),
})
const viewUiDimensionCandidateDimensionGroupSchema = viewUiDimensionCandidateCommonSchema.extend({
  type: z.literal('dimensionGroup'),
  groupId: z.string(),
})
const viewUiDimensionCandidateDimensionAliasSchema = viewUiDimensionCandidateCommonSchema.extend({
  type: z.literal('alias'),
  alias: z.string(),
})

export const viewUiDimensionCandidateSchema = z.union([
  viewUiDimensionCandidatePropertySchema,
  viewUiDimensionCandidateFieldNameSchema,
  viewUiDimensionCandidateDimensionGroupSchema,
  viewUiDimensionCandidateDimensionAliasSchema,
])
export type ViewUiDimensionCandidate = z.infer<typeof viewUiDimensionCandidateSchema>
